import { makeStyles } from '@mui/styles';
export default makeStyles(() => ({
  modalBody: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    height: '100%',
    justifyContent: 'center',
  },
  container: {
    width: 374,
    height: 312,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 5px 30px #00000026',
    border: ' 1px solid #E6E6E6',
    borderRadius: 14,
    paddingBottom: 32,
    paddingTop: 32,
    paddingLeft: 24,
    paddingRight: 24,
    boxSizing: 'border-box',
    alignSelf: 'center',
    '@media (max-width: 600px)': {
      width: '90%',
      maxWidth: 374,
      border: ' 0px solid #E6E6E6',
    },
  },
  triangle: {
    width: 48,
    height: 48,
    marginBottom: 16,
  },
  title: {
    fontSize: 22,
    fontWeight: '500',
    marginTop: 0,
    marginBottom: 0,
  },
  errorMessageContainer: { flex: 1, flexWrap: 'wrap' },
  text: {
    fontSize: 16,
    color: '#949494',
    textAlign: 'center',
    fontWeight: '400',
    marginTop: 14,
    marginBottom: 17,
    height: 68,
  },
  button: {
    width: '100%',
    height: 52,
    backgroundColor: '#4CAF50',
    borderRadius: 12,
    borderStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '400',
  },
}));

export const modal = {
  backgroundColor: '#FFFFFF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
